import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Tabs, 
  Tab, 
  List, 
  ListItem, 
  ListItemText, 
  Divider,
  Chip,
  Link,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`catehetic-tabpanel-${index}`}
      aria-labelledby={`catehetic-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const SectorulCateheticEducational: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const departamente = [
    {
      nume: "Departamentul Catehetic",
      responsabil: "Pr. Nicolae Rădoi",
      locatie: "Bergamo",
      responsabilitati: [
        "Instruirea religioasă a copiilor și tinerilor",
        "Pregătirea pentru sacramente",
        "Organizarea cursurilor de catehism"
      ]
    },
    {
      nume: "Departamentul Educațional", 
      responsabil: "Pr. Maria Gălățeanu",
      locatie: "Roma",
      responsabilitati: [
        "Coordonarea activităților educaționale",
        "Formarea continuă a personalului",
        "Dezvoltarea programelor educaționale"
      ]
    },
    {
      nume: "Centrul de Studii Teologice",
      responsabil: "Pr. Pompei Păcurar", 
      locatie: "Milano Nord",
      responsabilitati: [
        "Cercetare teologică",
        "Formarea academică",
        "Dezvoltarea resurselor educaționale"
      ]
    },
    {
      nume: "Uniunea de Formare Continuă",
      responsabil: "Protos. Maxim Morariu",
      locatie: "Episcopia",
      responsabilitati: [
        "Formarea continuă a clerului",
        "Seminarii și workshop-uri",
        "Dezvoltarea profesională"
      ]
    }
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Catehetic - Educațional
      </Typography>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="catehetic tabs">
          <Tab label="Departamente" />
          <Tab label="Personal" />
          <Tab label="Programe" />
          <Tab label="Resurse" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <Grid container spacing={3}>
          {departamente.map((departament, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="primary">
                    {departament.nume}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Responsabil: {departament.responsabil} ({departament.locatie})
                  </Typography>
                  <List>
                    {departament.responsabilitati.map((responsabilitate, idx) => (
                      <React.Fragment key={idx}>
                        <ListItem>
                          <ListItemText 
                            primary={responsabilitate}
                            secondary=""
                          />
                        </ListItem>
                        {idx < departament.responsabilitati.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Personalul Sectorului
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nume</TableCell>
                    <TableCell>Funcție</TableCell>
                    <TableCell>Locație</TableCell>
                    <TableCell>Departament</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Pr. Nicolae Rădoi</TableCell>
                    <TableCell>Responsabil Departament Catehetic</TableCell>
                    <TableCell>Bergamo</TableCell>
                    <TableCell>Departamentul Catehetic</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Pr. Maria Gălățeanu</TableCell>
                    <TableCell>Responsabil Departament Educațional</TableCell>
                    <TableCell>Roma</TableCell>
                    <TableCell>Departamentul Educațional</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Pr. Pompei Păcurar</TableCell>
                    <TableCell>Responsabil Centrul de Studii Teologice</TableCell>
                    <TableCell>Milano Nord</TableCell>
                    <TableCell>Centrul de Studii Teologice</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Protos. Maxim Morariu</TableCell>
                    <TableCell>Responsabil Uniunea de Formare Continuă</TableCell>
                    <TableCell>Episcopia</TableCell>
                    <TableCell>Uniunea de Formare Continuă</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Pr. Gavril Pop</TableCell>
                    <TableCell>Consilier</TableCell>
                    <TableCell>Milano</TableCell>
                    <TableCell>Uniunea de Formare Continuă</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Programe Catehetice
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Catehism pentru copii (6-12 ani)"
                      secondary="Instruire religioasă de bază"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Pregătire pentru botez"
                      secondary="Cursuri pentru părinți și nași"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Pregătire pentru cununie"
                      secondary="Instruire pentru cuplurile tinere"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Formare pentru adulți"
                      secondary="Cursuri de cunoaștere a credinței"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Programe Educaționale
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Seminarii teologice"
                      secondary="Formare academică pentru cler"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Workshop-uri de formare"
                      secondary="Dezvoltare profesională continuă"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Cercetare teologică"
                      secondary="Studii și publicații științifice"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Conferințe și simpozioane"
                      secondary="Evenimente de formare și dezbatere"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Resurse Educaționale
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Manualele de catehism"
                      secondary="Materiale pentru toate vârstele"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Biblioteca teologică"
                      secondary="Cărți și publicații specializate"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Resurse multimedia"
                      secondary="Video-uri, prezentări, materiale interactive"
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText 
                      primary="Platforma online"
                      secondary="Cursuri și resurse digitale"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Statut Sector
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                  <Chip label="Activ" color="success" />
                  <Chip label="Educațional" color="primary" />
                  <Chip label="Catehetic" color="secondary" />
                </Box>
                <Typography variant="body2">
                  Sectorul Catehetic-Educațional coordonează toate activitățile 
                  de educație religioasă și formare teologică din cadrul eparhiei, 
                  asigurând dezvoltarea spirituală și intelectuală a comunității 
                  ortodoxe din Italia.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>
    </Box>
  );
};

export default SectorulCateheticEducational;
